<template>
  <div id="app">
    <Header class="header-pos"></Header>

    <router-view/>
    <Footer></Footer>
    <GoTop></GoTop>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style scoped>
  .header-pos {
    position: absolute;
    top: 0;
    left: 0;
    width:100%;
    z-index: 1000;
  }
  @media screen and (max-width: 768px) {
    .header-pos {
      position: unset;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue